export default {
  el: {
    colorpicker: {
      confirm: 'ยืนยัน',
      clear: 'ล้าง'
    },
    datepicker: {
      now: 'ตอนนี้',
      today: 'วันนี้',
      cancel: 'ยกเลิก',
      clear: 'ล้าง',
      confirm: 'ยืนยัน',
      selectDate: 'เลือกวันที่',
      selectTime: 'เลือกเวลา',
      startDate: 'วันที่เริ่ม',
      startTime: 'เวลาเริ่ม',
      endDate: 'วันที่สิ้นสุด',
      endTime: 'เวลาสิ้นสุด',
      prevYear: 'ปีก่อนหน้า',
      nextYear: 'ปีถัดไป',
      prevMonth: 'เดือนก่อนหน้า',
      nextMonth: 'เดือนถัดไป',
      year: 'ปี',
      month1: 'มกราคม',
      month2: 'กุมภาพันธ์',
      month3: 'มีนาคม',
      month4: 'เมษายน',
      month5: 'พฤษภาคม',
      month6: 'มิถุนายน',
      month7: 'กรกฎาคม',
      month8: 'สิงหาคม',
      month9: 'กันยายน',
      month10: 'ตุลาคม',
      month11: 'พฤศจิกายน',
      month12: 'ธันวาคม',
      weeks: {
        sun: 'อา.',
        mon: 'จ.',
        tue: 'อ.',
        wed: 'พ.',
        thu: 'พฤ.',
        fri: 'ศ.',
        sat: 'ส.'
      },
      months: {
        jan: 'ม.ค.',
        feb: 'ก.พ.',
        mar: 'มี.ค.',
        apr: 'เม.ย.',
        may: 'พ.ค.',
        jun: 'มิ.ย.',
        jul: 'ก.ค.',
        aug: 'ส.ค.',
        sep: 'ก.ย.',
        oct: 'ต.ค.',
        nov: 'พ.ย.',
        dec: 'ธ.ค.'
      }
    },
    select: {
      loading: 'กำลังโหลด',
      noMatch: 'ไม่พบข้อมูลที่ตรงกัน',
      noData: 'ไม่มีข้อมูล',
      placeholder: 'โปรดเลือก'
    },
    cascader: {
      noMatch: 'ไม่พบข้อมูลที่ตรงกัน',
      loading: 'กำลังโหลด',
      placeholder: 'โปรดเลือก',
      noData: 'ไม่มีข้อมูล'
    },
    pagination: {
      goto: 'ไปที่',
      pagesize: 'รายการ/หน้า',
      total: 'ทั้งหมด {total} รายการ',
      pageClassifier: 'หน้า'
    },
    messagebox: {
      title: 'ข้อความ',
      confirm: 'ยืนยัน',
      cancel: 'ยกเลิก',
      error: 'ข้อมูลไม่ถูกต้อง'
    },
    upload: {
      deleteTip: 'กดลบเพื่อลบ',
      delete: 'ลบ',
      preview: 'ดูตัวอย่าง',
      continue: 'ต่อไป'
    },
    table: {
      emptyText: 'ไม่มีข้อมูล',
      confirmFilter: 'ยืนยัน',
      resetFilter: 'รีเซ็ต',
      clearFilter: 'ทั้งหมด',
      sumText: 'ผลรวม'
    },
    tree: {
      emptyText: 'ไม่มีข้อมูล'
    },
    transfer: {
      noMatch: 'ไม่พบข้อมูลที่ตรงกัน',
      noData: 'ไม่มีข้อมูล',
      titles: ['รายการ', 'รายการที่เลือก'],
      filterPlaceholder: 'ป้อนคำค้นหา',
      noCheckedFormat: '{total} รายการ',
      hasCheckedFormat: 'เลือกแล้ว {checked}/{total} รายการ'
    },
    image: {
      error: 'ล้มเหลว'
    },
    pageHeader: {
      title: 'ย้อนกลับ'
    },
    popconfirm: {
      confirmButtonText: 'ตกลง',
      cancelButtonText: 'ยกเลิก'
    }
  }
}


